module.exports = __webpack_public_path__ + "static/demo-day-81a026bc317a26604bde05da997c85e1.jpeg";